import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import {
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { TopNavComponent } from '../shared/index';
import { SharedModule } from '../shared/shared.module';
import { SecComponent } from './';
import { Ng2BootstrapModule } from 'ng2-bootstrap';
import { DatePickerModule } from 'ng2-datepicker';

@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    RouterModule,
    BrowserModule,
    FormsModule,
    Ng2BootstrapModule.forRoot(),
    ReactiveFormsModule,
    DatePickerModule
  ],
  declarations: [SecComponent],
  exports: [SecComponent, TopNavComponent]
})

export class SecModule { }



// WEBPACK FOOTER //
// ./src/app/sec/sec.module.ts